import { render, staticRenderFns } from "./AlterarFoto.vue?vue&type=template&id=dea3cb76"
import script from "./AlterarFoto.vue?vue&type=script&lang=js"
export * from "./AlterarFoto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports